module.exports = __webpack_public_path__ + "static/hero-photobooths.7876a579.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hero-photobooths.jpg
// module id = 545
// module chunks = 184314132425989